import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AlertType } from './alert-type.enum';
import { NotifyService, Toast } from 'src/app/core/services/notify.service';

/** Shows the messages of {@link NotifyService} as a stack at the top of the screen. */
@Component({
    selector: 'app-global-alert',
    templateUrl: './global-alert.component.html',
    styleUrls: ['./global-alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, TranslatePipe]
})
export class GlobalAlertComponent {
  readonly notify = inject(NotifyService);
  readonly toasts = this.notify.toasts;

  onActionClick(toast: Toast): void {
    toast.action?.onClick();
    this.notify.dismiss(toast.id);
  }

  /** Share of the display time that is left, for the countdown bar. */
  progress(toast: Toast): number {
    return toast.duration > 0 ? Math.max(0, Math.min(100, (toast.remaining / toast.duration) * 100)) : 0;
  }

  /** Errors interrupt screen readers; the rest is announced politely. */
  role(toast: Toast): 'alert' | 'status' {
    return toast.type === AlertType.Error ? 'alert' : 'status';
  }

  getCssClass(toast: Toast): string {
    switch (toast.type) {
      case AlertType.Success: return 'success';
      case AlertType.Warning: return 'warning';
      case AlertType.Error:   return 'error';
      case AlertType.Info:    return 'info';
      default: return '';
    }
  }
}
